import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { ConfianceHero, Guarantees, SectionTitle, PHONE, PHONE_TEL } from "@/components/confiance/ConfianceTop";
import { Partners, Specialties, SecurePayment } from "@/components/confiance/ConfianceMiddle";
import { GoogleReviews } from "@/components/confiance/GoogleReviews";

const ADDRESS = "47 rue Jean Jaurès, 93200 Saint-Denis";
const MAP_SRC = `https://www.google.com/maps?q=${encodeURIComponent(`JyVis Assurances, ${ADDRESS}`)}&output=embed`;

const Agency = () => (
  <section className="max-w-6xl mx-auto px-5 py-16 md:py-20" data-testid="confiance-agency">
    <SectionTitle kicker="Notre agence" title="Venez nous rencontrer" />
    <div className="grid gap-8 md:grid-cols-5">
      <address className="not-italic md:col-span-2 space-y-4 text-slate-700">
        <p className="text-xl font-bold text-[#0A1864]">JyVis Assurances</p>
        <p className="flex gap-3"><MapPin className="w-5 h-5 text-[#0A1864] shrink-0" /> <span data-testid="agency-address">{ADDRESS}</span></p>
        <a href={`tel:${PHONE_TEL}`} className="flex gap-3 hover:text-[#0A1864]" data-testid="agency-phone"><Phone className="w-5 h-5 text-[#0A1864]" /> {PHONE}</a>
        <a href="mailto:contact@jyvis-assurances.com" className="flex gap-3 hover:text-[#0A1864]" data-testid="agency-email"><Mail className="w-5 h-5 text-[#0A1864]" /> contact@jyvis-assurances.com</a>
        <p className="flex gap-3" data-testid="agency-hours"><Clock className="w-5 h-5 text-[#0A1864] shrink-0" /> Lundi–samedi : 10h–12h30 / 13h30–18h</p>
      </address>
      <iframe title="JyVis Assurances sur Google Maps" src={MAP_SRC} loading="lazy" referrerPolicy="no-referrer-when-downgrade"
        className="md:col-span-3 w-full h-72 md:h-80 rounded-2xl border border-slate-200" data-testid="agency-map" />
    </div>
  </section>
);

const ConfianceFooter = () => (
  <footer className="bg-[#0A1864] text-white/70 text-sm" data-testid="confiance-footer">
    <div className="max-w-6xl mx-auto px-5 py-8 flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
      <p>JyVis Assurances est le nom commercial de LS ASSUR.</p>
      <div className="flex gap-5">
        <Link to="/mentions-legales" className="hover:text-white" data-testid="confiance-legal-link">Mentions légales</Link>
        <Link to="/politique-de-confidentialite" className="hover:text-white" data-testid="confiance-privacy-link">Confidentialité</Link>
      </div>
    </div>
  </footer>
);

export default function ConfiancePage() {
  return (
    <div className="min-h-screen bg-white" data-testid="confiance-page">
      <ConfianceHero />
      <Guarantees />
      <Partners />
      <Specialties />
      <section className="bg-slate-50" data-testid="confiance-reviews">
        <div className="max-w-6xl mx-auto px-5 py-16 md:py-20">
          <SectionTitle kicker="Avis Google" title="Ce que disent nos clients" />
          <GoogleReviews />
        </div>
      </section>
      <SecurePayment />
      <Agency />
      <ConfianceFooter />
    </div>
  );
}
